import { Collapse, Space, Typography } from 'antd';
import React from 'react';

const { Paragraph, Text } = Typography;

interface SchemaValidationErrorsProps {
    errors: {
        schema?: {
            [key: string]: {
                [key: string]: string[];
            };
        };
        object?: string;
        [key: string]: any;
    };
}

const SchemaValidationErrors: React.FC<SchemaValidationErrorsProps> = ({ errors }) => {
    const extractErrors = (errorData: any): string[] => {
        const errorMessages: string[] = [];

        if (!errorData) return errorMessages;

        if (typeof errorData === 'string') {
            errorMessages.push(errorData);
            return errorMessages;
        }

        const processNestedErrors = (obj: any, prefix: string = '') => {
            Object.entries(obj).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    // If the value is an array of error messages
                    value.forEach(msg => {
                        errorMessages.push(`${prefix}${key}: ${msg}`);
                    });
                } else if (typeof value === 'object' && value !== null) {
                    // If it's a nested object, recurse with updated prefix
                    processNestedErrors(value, `${prefix}${key} > `);
                } else if (value) {
                    // For direct key-value pairs
                    errorMessages.push(`${prefix}${key}: ${value}`);
                }
            });
        };

        if (errorData.schema) {
            processNestedErrors(errorData.schema);
        } else if (errorData.object) {
            errorMessages.push(errorData.object);
        } else {
            processNestedErrors(errorData);
        }

        return errorMessages;
    };

    const generateList = (errors: any) => {
        const extractedErrors = extractErrors(errors);
        return (
            <Paragraph>
                <ul style={{ textAlign: "left", margin: 0, paddingLeft: 20 }}>
                    {extractedErrors.map((err, index) => (
                        <li key={index}>{err}</li>
                    ))}
                </ul>
            </Paragraph>
        );
    };

    return (
        <Space orientation="vertical" style={{ width: '100%' }}>
            <Collapse
                bordered={false}
                style={{
                    backgroundColor: "#fff2f0",
                    borderColor: "#ffccc7",
                    marginBottom: "5px"
                }}
                items={[{
                    key: '1',
                    label: <Text>Schema Validation Failed</Text>,
                    children: generateList(errors),
                }]}
            />
        </Space>
    );
};

export default SchemaValidationErrors; 